import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Profile.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { conversationsService } from '../../services';
import { getExpertImage } from '../../utils/expertImages';

export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isExpertProfile, setIsExpertProfile] = useState(false);
  const [expertInfo, setExpertInfo] = useState(null);
  const [userInfo, setUserInfo] = useState({
    name: 'Nguyễn Văn A',
    email: 'nguyenvana@gmail.com',
    avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiBmaWxsPSIjMGVhNWU5Ii8+Cjx0ZXh0IHg9IjYwIiB5PSI2NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjI0IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPlU8L3RleHQ+Cjwvc3ZnPgo=',
    role: 'Bệnh nhân',
    specialization: 'Hỗ trợ sức khỏe tinh thần',
    experience: '2 năm',
    location: 'Thành phố Hồ Chí Minh, Việt Nam',
    phone: '+84 123 456 789',
    joinDate: 'Tháng 1 năm 2023',
    lastLogin: '2 giờ trước'
  });

  // Tải thông tin người dùng từ localStorage hoặc API
  useEffect(() => {
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
      setUserInfo(JSON.parse(savedUserInfo));
    }
    
    // Kiểm tra xem đây có phải là hồ sơ chuyên gia sử dụng tham số đường dẫn
    const pathParts = location.pathname.split('/');
    const profileId = pathParts[pathParts.length - 1];
    
    console.log('Đường dẫn Profile:', location.pathname);
    console.log('ID Profile từ đường dẫn:', profileId);
    
    if (profileId && profileId !== 'profile') {
      console.log('Đặt làm hồ sơ chuyên gia cho ID:', profileId);
      setIsExpertProfile(true);
      // Tải dữ liệu chuyên gia dựa trên ID
      loadExpertData(profileId);
    } else {
      console.log('Không phải hồ sơ chuyên gia, sử dụng thông tin người dùng');
    }
  }, [location.pathname]);

  // Tải dữ liệu chuyên gia từ cuộc hẹn hoặc API
  const loadExpertData = async (expertId) => {
    console.log('Đang tải dữ liệu chuyên gia cho ID:', expertId);
    
    try {
      // Đầu tiên, thử lấy thông tin chuyên gia từ localStorage (từ lịch hẹn)
      const savedExpertInfo = localStorage.getItem('selectedExpertInfo');
      if (savedExpertInfo) {
        const expertData = JSON.parse(savedExpertInfo);
        console.log('Tìm thấy thông tin chuyên gia trong localStorage:', expertData);
        setExpertInfo(expertData);
        return;
      }

      // Thử lấy thông tin chuyên gia từ dữ liệu cuộc hẹn
      const appointmentData = localStorage.getItem('currentAppointment');
      if (appointmentData) {
        const appointment = JSON.parse(appointmentData);
        if (appointment.therapist || appointment.therapistId) {
          console.log('Tìm thấy thông tin chuyên gia trong dữ liệu cuộc hẹn:', appointment.therapist);
          setExpertInfo(appointment.therapist);
          return;
        }
      }

      // Thử lấy thông tin chuyên gia từ danh sách chuyên gia trong localStorage
      const expertsList = localStorage.getItem('expertsList');
      if (expertsList) {
        const experts = JSON.parse(expertsList);
        const expert = experts.find(e => e.id === expertId || e.Id === expertId);
        if (expert) {
          console.log('Tìm thấy chuyên gia trong danh sách chuyên gia:', expert);
          setExpertInfo(expert);
          return;
        }
      }

      // Thử lấy thông tin chuyên gia từ therapistService
      try {
        const { therapistService } = await import('../../services');
        console.log('Gọi therapistService.getById với ID:', expertId);
        const expertData = await therapistService.getById(expertId);
        if (expertData) {
          console.log('Tìm thấy chuyên gia qua API:', expertData);
          // Ánh xạ phản hồi API sang định dạng mong đợi của chúng ta
          const mappedExpert = {
            id: expertData.id || expertData.Id,
            name: expertData.name || expertData.fullName || expertData.displayName || 'Bác sĩ Chuyên gia',
            specialty: expertData.specialty || expertData.specialization || 'Tâm lý học',
            experience: expertData.experience || expertData.yearsOfExperience || '5 năm',
            rating: expertData.rating || expertData.averageRating || 4.5,
            price: expertData.price || expertData.hourlyRate || '2.000.000đ/buổi',
            image: expertData.image || expertData.avatarUrl || expertData.avatar || expertData.avatar_url || expertData.profilePicture || 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=400&fit=crop&crop=face',
            description: expertData.description || expertData.bio || expertData.about || 'Chuyên gia tâm lý với nhiều năm kinh nghiệm trong việc hỗ trợ khách hàng.',
            availability: expertData.availability || expertData.isAvailable ? 'Có lịch' : 'Không có lịch',
            location: expertData.location || expertData.city || 'Thành phố Hồ Chí Minh',
            phone: expertData.phone || expertData.phoneNumber || '+84 123 456 789',
            email: expertData.email || expertData.emailAddress || 'expert@example.com',
            education: expertData.education || expertData.qualifications || 'Tiến sĩ Tâm lý học',
            certifications: expertData.certifications || expertData.credentials || ['Chứng chỉ Tâm lý học'],
            languages: expertData.languages || expertData.spokenLanguages || ['Tiếng Việt', 'Tiếng Anh'],
            joinDate: expertData.joinDate || expertData.createdAt || '2020',
            fullName: expertData.fullName || expertData.name || 'Bác sĩ Chuyên gia',
            displayName: expertData.displayName || expertData.name || 'Bác sĩ Chuyên gia'
          };
          setExpertInfo(mappedExpert);
          return;
        }
      } catch (apiError) {
        console.log('Cuộc gọi API thất bại, sử dụng dự phòng:', apiError);
      }

      // Dự phòng: Tạo hồ sơ chuyên gia từ dữ liệu có sẵn
      console.log('Tạo hồ sơ chuyên gia dự phòng cho ID:', expertId);
      setExpertInfo({
        id: expertId,
        name: "Bác sĩ Chuyên gia",
        specialty: "Tâm lý học",
        experience: "5 năm",
        rating: 4.5,
        price: "2.000.000đ/buổi",
        image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=400&fit=crop&crop=face",
        description: "Chuyên gia tâm lý với nhiều năm kinh nghiệm trong việc hỗ trợ khách hàng.",
        availability: "Có lịch",
        location: "Thành phố Hồ Chí Minh",
        phone: "+84 123 456 789",
        email: "expert@example.com",
        education: "Tiến sĩ Tâm lý học",
        certifications: ["Chứng chỉ Tâm lý học"],
        languages: ["Tiếng Việt", "Tiếng Anh"],
        joinDate: "2020",
        fullName: "Bác sĩ Chuyên gia",
        displayName: "Bác sĩ Chuyên gia"
      });

    } catch (error) {
      console.error('Lỗi khi tải dữ liệu chuyên gia:', error);
      // Sử dụng dự phòng tối thiểu
      setExpertInfo({
        id: expertId,
        name: "Bác sĩ Chuyên gia",
        specialty: "Tâm lý học",
        experience: "5 năm",
        rating: 4.5,
        price: "2.000.000đ/buổi",
        description: "Chuyên gia tâm lý với nhiều năm kinh nghiệm trong việc hỗ trợ khách hàng.",
        availability: "Có lịch",
        location: "Thành phố Hồ Chí Minh"
      });
    }
  };

  const handleBackToCalendar = () => {
    navigate('/appointment-calendar');
  };

  const handleViewCredentials = () => {
    // Điều hướng đến trang bằng cấp
    navigate('/credentials');
  };

  const handleBookAppointment = () => {
    navigate('/book-expert');
  };

  const handleStartChat = async () => {
    try {
      // Xác định ID người dùng mục tiêu - nếu là hồ sơ chuyên gia, sử dụng tham số expertId; nếu không thì quay lại ID hồ sơ hiện tại
      const urlParams = new URLSearchParams(location.search);
      const expertId = urlParams.get('expertId');
      const targetUserId = expertId || userInfo?.id || null;
      if (!targetUserId) {
        alert('Không thể xác định người dùng để trò chuyện');
        return;
      }

      // Lạc quan: đặt cờ openConversationId để messenger sẽ mở cuộc trò chuyện sau khi nó được tạo
      localStorage.setItem('openConversationTargetUser', targetUserId);

      // Thử bắt đầu/tìm cuộc trò chuyện trên backend
      const conv = await conversationsService.startConversationWithUser(targetUserId);
      const convId = conv?.id || conv?.conversationId || conv?._id;
      if (convId) {
        // Lưu ID cuộc trò chuyện cho giao diện chat và điều hướng
        localStorage.setItem('openConversationId', convId);
        // điều hướng đến trang messenger đầy đủ
        navigate('/free-chat/messenger');
      } else {
        // dự phòng: điều hướng đến messenger để người dùng có thể bắt đầu thủ công
        navigate('/free-chat/messenger');
      }
    } catch (err) {
      console.error('Bắt đầu trò chuyện thất bại', err);
      alert('Không thể bắt đầu trò chuyện');
    }
  };

  const handleDownloadReport = () => {
    // Điều hướng đến trang báo cáo
    navigate('/reports');
  };

  const handleSeeDetails = () => {
    // Điều hướng đến trang chi tiết đánh giá
    navigate('/assessment-details');
  };

  const handleEditProfile = () => {
    // Điều hướng đến lịch hẹn với phần chi tiết người dùng được kích hoạt nhưng không được làm nổi bật
    navigate('/appointment-calendar?section=user-details&edit=true');
  };

  return (
    <div className="profile-page page-with-header">
      <Header />
      
      <div className="profile-container">
        {/* Tiêu đề Hồ sơ */}
        <div className="profile-header">
          <div className="profile-info">
            <div className="profile-avatar">
              <img src={isExpertProfile ? getExpertImage(expertInfo) : userInfo.avatar} alt={isExpertProfile ? expertInfo?.name : userInfo.name} />
            </div>
            <div className="profile-details">
              <h1>{isExpertProfile ? expertInfo?.name : userInfo.name}</h1>
              <div className="profile-tags">
                <span className="tag">{isExpertProfile ? expertInfo?.specialty : userInfo.role}</span>
                <span className="tag">{isExpertProfile ? expertInfo?.experience : userInfo.specialization}</span>
                {isExpertProfile && (
                  <span className="tag rating-tag">⭐ {expertInfo?.rating}/5</span>
                )}
              </div>
              <p className="profile-description">
                {isExpertProfile 
                  ? expertInfo?.description
                  : (userInfo.role === 'Patient' 
                    ? `Chào mừng bạn đến với hành trình sức khỏe tinh thần. Bạn đã tham gia với chúng tôi được ${userInfo.experience} và chúng tôi ở đây để hỗ trợ sức khỏe của bạn.`
                    : `Dr. Duc cung cấp hỗ trợ đồng cảm cho những người đang trải qua đau buồn, mất mát và trầm cảm. Ông giúp khách hàng tìm ra con đường chữa lành và hy vọng mới.`
                  )
                }
              </p>
            </div>
          </div>
          <div className="profile-actions">
            {isExpertProfile ? (
              <>
                <button className="book-appointment-btn" onClick={handleBookAppointment}>Đặt lịch hẹn</button>
                <button className="view-credentials-btn" onClick={handleViewCredentials}>Xem bằng cấp</button>
                <button className="start-chat-btn" onClick={handleStartChat}>Bắt đầu trò chuyện</button>
              </>
            ) : (
              <>
                <button className="edit-profile-btn" onClick={handleEditProfile}>Chỉnh sửa hồ sơ</button>
                <button className="view-credentials-btn" onClick={handleViewCredentials}>Xem bằng cấp</button>
                <button className="book-appointment-btn" onClick={handleBookAppointment}>Đặt lịch hẹn</button>
                <button className="start-chat-btn" onClick={handleStartChat}>Bắt đầu trò chuyện</button>
              </>
            )}
          </div>
        </div>

        {/* Phần Giới thiệu */}
        <div className="about-section">
          <div className="about-content">
            <div className="about-text">
              <h2>Về {isExpertProfile ? expertInfo?.name : userInfo.name}</h2>
              <p>
                {isExpertProfile 
                  ? expertInfo?.description
                  : (userInfo.role === 'Patient' 
                    ? `${userInfo.name} đã là một phần của cộng đồng sức khỏe tinh thần của chúng tôi trong ${userInfo.experience}. Chúng tôi cam kết cung cấp hỗ trợ và hướng dẫn cá nhân hóa trong suốt hành trình sức khỏe tinh thần của bạn.`
                    : `Dr. Duc có mười năm kinh nghiệm giúp đỡ các cá nhân vượt qua những thách thức sức khỏe tinh thần. Ông chuyên về các phương pháp trị liệu dựa trên bằng chứng và tạo ra một môi trường an toàn, hỗ trợ để khách hàng khám phá suy nghĩ và cảm xúc của họ.`
                  )
                }
              </p>
            </div>
            <div className="about-details">
              <div className="detail-card">
                <h4>{isExpertProfile ? 'Học vấn' : (userInfo.role === 'Patient' ? 'Thành viên từ' : 'Nền tảng chuyên môn')}</h4>
                <p>{isExpertProfile ? expertInfo?.education : (userInfo.role === 'Patient' ? `Tham gia từ ${userInfo.joinDate}` : 'Dr. Duc tốt nghiệp từ Đại học Sức khỏe Tinh thần với bằng Tiến sĩ Tâm lý học.')}</p>
              </div>
              <div className="detail-card">
                <h4>{isExpertProfile ? 'Địa điểm' : (userInfo.role === 'Patient' ? 'Địa điểm' : 'Phương pháp trị liệu')}</h4>
                <p>{isExpertProfile ? expertInfo?.location : (userInfo.role === 'Patient' ? userInfo.location : 'Sử dụng các kỹ thuật dựa trên bằng chứng để thúc đẩy sự phát triển cá nhân.')}</p>
              </div>
              {isExpertProfile && (
                <div className="detail-card">
                  <h4>Giá</h4>
                  <p>{expertInfo?.price}</p>
                </div>
              )}
              {isExpertProfile && (
                <div className="detail-card">
                  <h4>Tình trạng</h4>
                  <p>{expertInfo?.availability}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Phần Đánh giá */}
        <div className="testimonials-section">
          <div className="testimonials-header">
            <h2>Những gì mọi người nói</h2>
            <div className="testimonial-nav">
              <button className="nav-arrow">‹</button>
              <button className="nav-arrow">›</button>
            </div>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Learn to Mend đã giúp tôi tìm được một nhà trị liệu thực sự hiểu những khó khăn của tôi. Nền tảng rất dễ sử dụng và tôi cảm thấy bình yên hơn nhiều."</p>
              <div className="testimonial-author">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjMGVhNWU5Ii8+Cjx0ZXh0IHg9IjIwIiB5PSIyNCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPk1MPC90ZXh0Pgo8L3N2Zz4K" alt="Mai L." />
                <div className="author-info">
                  <span className="author-name">Mai L.</span>
                  <span className="author-location">Thành phố Hồ Chí Minh</span>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p>"Tôi đã do dự về trị liệu trực tuyến, nhưng nền tảng này đã làm cho nó trở nên dễ tiếp cận và thoải mái. Đây là một bước ngoặt cho hỗ trợ sức khỏe tinh thần tại Việt Nam."</p>
              <div className="testimonial-author">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjMGVhNWU5Ii8+Cjx0ZXh0IHg9IjIwIiB5PSIyNCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPkFOPC90ZXh0Pgo8L3N2Zz4K" alt="An N." />
                <div className="author-info">
                  <span className="author-name">An N.</span>
                  <span className="author-location">Hà Nội</span>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p>"Khả năng lọc theo ngôn ngữ và chuyên môn đã vô cùng hữu ích. Tôi đã tìm được nhà trị liệu hoàn hảo giúp tôi vượt qua lo âu."</p>
              <div className="testimonial-author">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjMGVhNWU5Ii8+Cjx0ZXh0IHg9IjIwIiB5PSIyNCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPlFEPC90ZXh0Pgo8L3N2Zz4K" alt="Quang D." />
                <div className="author-info">
                  <span className="author-name">Quang D.</span>
                  <span className="author-location">Đà Nẵng</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Phần Chuyên môn */}
        <div className="specializations-section">
          <h2>Chuyên môn</h2>
          <p>Các lĩnh vực chuyên môn mà Dr. Duc tập trung vào.</p>
          <div className="specializations-grid">
            <div className="specialization-card">
              <div className="specialization-icon">🧠</div>
              <h3>CBT</h3>
              <p>Hiệu quả cho lo âu và trầm cảm</p>
            </div>
            <div className="specialization-card">
              <div className="specialization-icon">💬</div>
              <h3>Trị liệu nói chuyện</h3>
              <p>Cuộc trò chuyện mở để tạo ra những hiểu biết</p>
              <p>Không gian an toàn để thể hiện bản thân</p>
            </div>
          </div>
        </div>

        {/* Tài liệu được khuyến nghị */}
        <div className="readings-section">
          <h2>Tài liệu được khuyến nghị</h2>
          <div className="readings-grid">
            <div className="reading-card">
              <div className="book-placeholder">📖</div>
              <h4>Chiến lược đối phó</h4>
              <p>Học các phương pháp quản lý căng thẳng và lo âu hiệu quả.</p>
            </div>
            <div className="reading-card">
              <div className="book-placeholder">📖</div>
              <h4>Kỹ thuật chánh niệm</h4>
              <p>Khám phá các thực hành chánh niệm cho sức khỏe tinh thần.</p>
            </div>
          </div>
        </div>

        {/* Buổi trị liệu */}
        <div className="sessions-section">
          <h2>Buổi trị liệu</h2>
          <p>Hiểu về tác động của trị liệu.</p>
          <div className="sessions-stats">
            <div className="session-stat">
              <h3>350</h3>
              <p>Buổi đã hoàn thành</p>
              <span className="stat-note">Phương pháp từng bước</span>
            </div>
            <div className="session-stat">
              <h3>96%</h3>
              <p>Sự hài lòng của bệnh nhân</p>
              <span className="stat-note">Ổn định</span>
            </div>
          </div>
        </div>

        {/* Thống kê hồ sơ */}
        <div className="profile-stats-section">
          <h2>Thống kê hồ sơ</h2>
          <p>Tổng quan về hoạt động của bạn</p>
          <div className="stats-actions">
            <button className="download-report-btn" onClick={handleDownloadReport}>Tải báo cáo</button>
            <button className="see-details-btn" onClick={handleSeeDetails}>Xem chi tiết</button>
          </div>
          <div className="stats-grid">
            <div className="stat-item">
              <h3>15</h3>
              <p>Bệnh nhân đã hoàn thành</p>
              <span className="stat-change">+5</span>
            </div>
            <div className="stat-item">
              <h3>8</h3>
              <p>Kỹ năng đã học</p>
              <span className="stat-change">+2</span>
            </div>
            <div className="stat-item">
              <h3>25</h3>
              <p>Khách hàng đã phục vụ</p>
              <span className="stat-change">0</span>
            </div>
          </div>
        </div>

        {/* Nút Quay lại Lịch */}
        <div className="back-navigation">
          <button className="back-to-calendar-btn" onClick={handleBackToCalendar}>
            ← Quay lại Lịch
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}


